import React, { useContext } from 'react';
import { EventBus, EventBusService } from '../../../services/EventBusService';

type ModalProps = {
  component: JSX.Element;
  fullscreenOptions?: { enabled: boolean; headerContent?: JSX.Element };
  options?: Omit<ReactModal.Props, 'isOpen' | 'onRequestClose'>;
  displayType?: DisplayType;
};

type DisplayType = 'image-box' | 'video-box';

type busType = {
  close: () => void;
  open: (params: ModalProps) => void;
};

const AutoModalContext = React.createContext<EventBus<busType> | undefined>(
  new EventBusService().createEventBus<busType>('AutoModal')
);

function useAutoModal() {
  return useContext(AutoModalContext);
}

export {
  type ModalProps,
  type busType,
  type DisplayType,
  AutoModalContext,
  useAutoModal
};
